import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import AuthLayout from '../../../components/shared/AuthLayout/AuthLayout';
import ButtonWithIcon from '../../../components/shared/ButtonWithIcon/ButtonWithIcon';
import { createOrganizationAccessRequest } from '../../../redux/actions/authActions';
import { getCurrentStep } from '../../../redux/actions/stepsAction';

import styles from './RequestAccess.module.scss';

const RequestAccess = () => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { currentUser, organizationAccessRequestLoading: loading } = useSelector((state) => state.authReducer);

  const handleRequestAccess = () => {
    const organizationId = localStorage.getItem('generalSignupOrganizationId');

    if (currentUser?.user?.id && organizationId) {
      const requestData = {
        user_id: currentUser.user.id,
        organization_id: parseInt(organizationId, 10),
      };

      dispatch(
        createOrganizationAccessRequest(requestData, () => {
          dispatch(getCurrentStep());
          setTimeout(() => {
            navigate('/dashboard', { replace: true });
          }, 2000);
        })
      );
    }
  };

  return (
    <AuthLayout>
      <div className={styles.container}>
        <div className={styles.formWrapper}>
          <div className={styles.header}>
            <h2 className={styles.headerText}>{t('signUp.accessRequired')}</h2>
          </div>

          <div className={styles.messageWrapper}>
            <p className={styles.errorMessage}>{t('signUp.noAccessMessage')}</p>
            <p className={styles.subMessage}>{t('signUp.requestAccessMessage')}</p>
          </div>

          <div className={styles.buttonWrapper}>
            <ButtonWithIcon
              imgClassName="btn-icon-36"
              containerClass="w-100"
              text={t('buttons.requestAccess')}
              textClassName="btn-icon-text-primary-40"
              variant="primary-36"
              disabled={loading}
              onClick={handleRequestAccess}
            />
          </div>
        </div>
      </div>
    </AuthLayout>
  );
};

export default RequestAccess;
